export default "__VITE_ASSET__CnqFmvgE__"